<div class="modal-content m-0">
  <div class="modal-header">
    <p class="modal-title">
      {{ 'pricing.country.details.title' | translate }}
    </p>
    <i
      class="fa-light fa-xmark ms-auto cursor-pointer"
      data-cy="close-icon"
      (click)="modalRef.close()"
    ></i>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-12">
        <div class="d-flex justify-content-between align-items-end">
          <p class="caption mb-0">
            {{ 'pricing.country.details.basicInfo' | translate }}
          </p>
          <button
            *appRequirePermission="'pricing.country.actions'"
            class="icon-btn mb-1 me-1"
            placement="left"
            type="button"
            triggers="hover"
            data-cy="country-edit-currency-btn"
            [class.icon-btn-sm]="!coreUtilsService.tabletMode()"
            [class.icon-btn-lg]="coreUtilsService.tabletMode()"
            [ngbTooltip]="'pricing.country.details.editCurrency' | translate"
            (click)="openCurrencyDialog($event)"
          >
            <i class="fa-light fa-euro-sign fa-sm"></i>
          </button>
        </div>
      </div>
    </div>
    <hr class="mt-0" />
    <div class="row mb-3">
      <div class="col-12 col-md-6 row align-items-center mb-2">
        <label class="label col-12 col-sm-4 mb-0 text-sm-end">{{
          'pricing.country.details.countryName' | translate
        }}</label>
        <div class="col-12 col-sm-8">
          {{ pricingCountry()?.name }}
        </div>
      </div>
      <div class="col-12 col-md-6 row align-items-center mb-2">
        <label class="label col-12 col-sm-4 mb-0 text-sm-end">{{
          'pricing.country.details.currency' | translate
        }}</label>
        <div class="col-12 col-sm-8">
          {{ pricingCountry()?.currency ?? '—' }}
        </div>
      </div>
      @if (pricingCountry()?.notes) {
        <div class="col-12 row align-items-center mb-2">
          <label class="label col-12 col-sm-2 mb-0 text-sm-end">{{
            'pricing.country.details.notes' | translate
          }}</label>
          <div class="col-12 col-sm-10">
            {{ pricingCountry()?.notes }}
          </div>
        </div>
      }
    </div>
    <ng-container *appRequirePermission="'pricing.country.actions'">
      <div class="row mt-1">
        <p class="caption mb-0 col-9">
          {{ 'pricing.country.details.addPrice' | translate }}
        </p>
      </div>
      <hr class="mt-0" />
      @if (countryId()) {
        <app-country-bundle-price-form [countryId]="countryId()" />
      }
    </ng-container>
    <div class="row mt-1">
      <p class="caption mb-0 col-9">
        {{
          'pricing.country.details.titleBundles'
            | translate: { country: pricingCountry()?.name }
        }}
      </p>
      <div
        class="col-3 text-end"
        *appRequirePermission="'pricing.country.actions'"
      >
        <button
          type="button"
          class="icon-btn mb-1 me-1"
          [class.icon-btn-sm]="!coreUtilsService.tabletMode()"
          [class.icon-btn-lg]="coreUtilsService.tabletMode()"
          (click)="openBulkPriceDialog($event)"
          data-cy="country-bulk-edit-prices-btn"
          placement="left"
          [ngbTooltip]="'pricing.country.details.bulkEdit.button' | translate"
        >
          <i class="fa-light fa-pencil fa-sm"></i>
        </button>
      </div>
    </div>
    <hr class="mt-0" />
    <div class="row mb-3">
      <div class="col-12">
        <app-data-table [configuration]="bundleDataTableConfiguration" />
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button
      ngbAutoFocus
      type="button"
      class="btn btn-clear"
      data-cy="close-btn"
      (click)="modalRef.close()"
    >
      {{ 'common.buttons.btnClose' | translate }}
    </button>
  </div>
</div>

<ng-template #wspColumnTemplate let-row="row">
  <ng-container
    *ngTemplateOutlet="priceCellTemplate; context: { price: row.wsp }"
  />
</ng-template>

<ng-template #eupColumnTemplate let-row="row">
  <ng-container
    *ngTemplateOutlet="priceCellTemplate; context: { price: row.eup }"
  />
</ng-template>

<ng-template #priceCellTemplate let-price="price">
  @if (price?.pivot?.price !== null && price?.pivot?.price !== undefined) {
    <div class="caption">
      {{ price.pivot.price | number: '1.2-2' }}
      {{ pricingCountry()?.currency }}
      @if (price.pivot.validFrom) {
        <span class="text-muted">
          ({{ price.pivot.validFrom | date: 'dd.MM.yyyy' }})
        </span>
      }
    </div>
  } @else {
    <div class="caption text-danger">
      {{ 'pricing.country.details.missingPrice' | translate }}
    </div>
  }
</ng-template>

<ng-template #bundleNameColumnTemplate let-row="row">
  <div class="caption">{{ row.name }}</div>
</ng-template>

<ng-template #generatedByColumnTemplate let-row="row">
  @if (getLatestPrice(row)?.pivot?.generatedBy; as generatedBy) {
    <span class="caption">
      <app-user-display [userId]="generatedBy" />
    </span>
  }
</ng-template>
